import { gql } from '@apollo/client';

export const GET_BATCH_REPORT_DOWNLOAD_URLS = gql`
  query ReportQuery($reportIds: [Long!]!, $warehouseId: Long!) {
    getBatchReportDownloadUrlsForPickup(reportIds: $reportIds, warehouseId: $warehouseId)
  }
`;

export interface GetBatchReportDownloadUrlsResponse {
  getBatchReportDownloadUrlsForPickup: string[];
}

export interface GetBatchReportDownloadUrlsVariables {
  reportIds: number[];
  warehouseId: string | number;
}